var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.294,
    height: 21.837,
    viewBox: "0 0 26.294 21.837",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "truck",
    transform: "translate(-0.2 -2.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1105",
    "data-name": "Rectangle 1105",
    d: "M.091-.8H16.8a.891.891,0,0,1,.891.891V14.575a.891.891,0,0,1-.891.891H.091A.891.891,0,0,1-.8,14.575V.091A.891.891,0,0,1,.091-.8ZM15.912.983H.983v12.7H15.912Z",
    transform: "translate(1 3)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2144",
    "data-name": "Path 2144",
    d: "M16.091,7.2h4.457a.891.891,0,0,1,.63.261L24.521,10.8a.891.891,0,0,1,.261.63V17a.891.891,0,0,1-.891.891h-7.8A.891.891,0,0,1,15.2,17V8.091A.891.891,0,0,1,16.091,7.2Zm4.087,1.783h-3.2v7.13H23V11.8Z",
    transform: "translate(1.712 0.571)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_211",
    "data-name": "Ellipse 211",
    d: "M2.877-.8A3.677,3.677,0,1,1-.8,2.877,3.681,3.681,0,0,1,2.877-.8Zm0,5.571A1.894,1.894,0,1,0,.983,2.877,1.9,1.9,0,0,0,2.877,4.771Z",
    transform: "translate(3.228 17.484)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_212",
    "data-name": "Ellipse 212",
    d: "M2.877-.8A3.677,3.677,0,1,1-.8,2.877,3.681,3.681,0,0,1,2.877-.8Zm0,5.571A1.894,1.894,0,1,0,.983,2.877,1.9,1.9,0,0,0,2.877,4.771Z",
    transform: "translate(17.712 17.484)",
    fill: "#333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.f2bee191e9148d8211cd1e3f85028857.svg";
export { ForwardRef as ReactComponent };